import React from "react";

import PropTypes from "prop-types";

import RbAutocompleteField from "components/RbAutocompleteField";
import RbButton from "components/RbButton";
import RbGrid from "components/RbGrid";
import RbNumberField from "components/RbNumberField";
import RbTextField from "components/RbTextField";
import FieldsProvider from "fields/components/FieldsProvider";
import useFields from "fields/hooks/useFields";

const productSortFields = [
  {
    label: "Name A-Z",
    value: {
      field: "NAME",
      order: "ASC",
    },
  },
  {
    label: "Name Z-A",
    value: {
      field: "NAME",
      order: "DESC",
    },
  },
  {
    label: "Price low to high",
    value: {
      field: "PRICE",
      order: "ASC",
    },
  },
  {
    label: "Price high to low",
    value: {
      field: "PRICE",
      order: "DESC",
    },
  },
];
function ProductsSearchParams(props) {
  const { onSearch } = props;

  const { fields, handleChange } = useFields();

  const handleSearch = React.useCallback(
    (event) => {
      event.preventDefault();
      onSearch(fields.values);
    },
    [fields.values, onSearch]
  );

  const getOptionLabel = React.useCallback((op) => op.label || "", []);

  const getOptionSelected = React.useCallback(
    (op, value) =>
      op.value.field === value.field && op.value.order === value.order,
    []
  );

  return (
    <FieldsProvider fields={fields} onChange={handleChange}>
      <form noValidate onSubmit={handleSearch}>
        <RbGrid container columnGap={3} rowGap={4}>
          <RbGrid item xs={12} md={3}>
            <RbTextField fieldName="filter.name.contains" label="Name" />
          </RbGrid>
          <RbGrid item xs={6} md={2}>
            <RbNumberField fieldName="filter.price.min" label="Min price" />
          </RbGrid>
          <RbGrid item xs={6} md={2}>
            <RbNumberField fieldName="filter.price.max" label="Max price" />
          </RbGrid>
          <RbGrid item xs={12} md={2}>
            <RbAutocompleteField
              fieldName="sort"
              label="Order by"
              getOptionLabel={getOptionLabel}
              getOptionSelected={getOptionSelected}
              options={productSortFields}
            />
          </RbGrid>
          <RbGrid
            item
            xs={12}
            md={1}
            pt={{ xs: 0, md: 5 }}
            pb={{ xs: 4, md: 0 }}
          >
            <RbButton
              variant="contained"
              type="submit"
              fullWidth
              color="primary"
            >
              Search
            </RbButton>
          </RbGrid>
        </RbGrid>
      </form>
    </FieldsProvider>
  );
}

ProductsSearchParams.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

ProductsSearchParams.defaultProps = {};

export default React.memo(ProductsSearchParams);
